import { formatAmount } from "../utils/Utils";

export enum BulkTypes {
    special = 'special',
    group = 'group',
    event = 'event',
    city = 'city',
    distanceFromMyself = 'distanceFromMyself',
    userAttribute = 'userAttribute',
}

export interface BulkPayment {
    id: string;
    type: BulkTypes;
    name: string;
    imgUrl?: string;
    recipientsCount: number;
    filters?: {
        badge?: string;
    }
}

export const getDisplayNameBulkPayment = (bulkPayment: BulkPayment): string => {
    if(bulkPayment.recipientsCount > 0) {
        return `${bulkPayment.name} (${formatAmount(bulkPayment.recipientsCount)})`;
    }
    else {
        return bulkPayment.name ?? '';
    }
}